import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as n } from "./maybe.js";
import t from "./RandomLCG.js";

function r(n) {
  if (!n) return;
  return n.length > 0 ? n[0] : void 0;
}

function e(n) {
  if (!n) return;
  var t = n.length;
  return t > 0 ? n[t - 1] : void 0;
}

function o(n) {
  return n;
}

function f(n) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : o;
  if (!n || 0 === n.length) return;
  var r = n[0],
      e = t(r);

  for (var _o = 1; _o < n.length; ++_o) {
    var _f = n[_o],
        _u = Number(t(_f));

    _u > e && (e = _u, r = _f);
  }

  return r;
}

function u(n) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : o;
  return f(n, function (n) {
    return -t(n);
  });
}

function i(n, t) {
  return t ? n.filter(function (n, r, e) {
    return e.findIndex(t.bind(null, n)) === r;
  }) : n.filter(function (n, t, r) {
    return r.indexOf(n) === t;
  });
}

function l(t, r, e) {
  if (n(t) && n(r)) return !0;
  if (n(t) || n(r) || t.length !== r.length) return !1;

  if (e) {
    for (var _n = 0; _n < t.length; _n++) {
      if (!e(t[_n], r[_n])) return !1;
    }
  } else for (var _n2 = 0; _n2 < t.length; _n2++) {
    if (t[_n2] !== r[_n2]) return !1;
  }

  return !0;
}

function c(n, t, r) {
  var e, o;
  return r ? (e = t.filter(function (t) {
    return !n.some(function (n) {
      return r(n, t);
    });
  }), o = n.filter(function (n) {
    return !t.some(function (t) {
      return r(t, n);
    });
  })) : (e = t.filter(function (t) {
    return !n.includes(t);
  }), o = n.filter(function (n) {
    return !t.includes(n);
  })), {
    added: e,
    removed: o
  };
}

function s(n, t, r) {
  return n && t ? r ? n.filter(function (n) {
    return t.findIndex(function (t) {
      return r(n, t);
    }) > -1;
  }) : n.filter(function (n) {
    return t.indexOf(n) > -1;
  }) : [];
}

function a(n) {
  return n && "number" == typeof n.length;
}

function h(n, t) {
  var r = n.length;
  if (0 === r) return [];
  var e = [];

  for (var _o2 = 0; _o2 < r; _o2 += t) {
    e.push(n.slice(_o2, _o2 + t));
  }

  return e;
}

var d = !!Array.prototype.fill;

function g(n, t) {
  if (d) return new Array(n).fill(t);
  var r = new Array(n);

  for (var _e = 0; _e < n; _e++) {
    r[_e] = t;
  }

  return r;
}

function m(n, t) {
  void 0 === t && (t = n, n = 0);
  var r = new Array(t - n);

  for (var _e2 = n; _e2 < t; _e2++) {
    r[_e2 - n] = _e2;
  }

  return r;
}

function p(n, t, r) {
  var e = n.length;
  var o = 0,
      f = e - 1;

  for (; o < f;) {
    var _r = o + Math.floor((f - o) / 2);

    t > n[_r] ? o = _r + 1 : f = _r;
  }

  var u = n[o];
  return r ? t >= n[e - 1] ? -1 : u === t ? o : o - 1 : u === t ? o : -1;
}

function x(n, t, r) {
  if (!n || 0 === n.length) return;
  var e = n.length - 1,
      o = n[0];
  if (t <= r(o)) return o;
  var f = n[e];
  if (t >= r(f)) return f;
  var u = 0,
      i = 0,
      l = e;

  for (; u < l;) {
    i = u + Math.floor((l - u) / 2);

    var _o3 = n[i],
        _f2 = r(_o3);

    if (_f2 === t) return _o3;

    if (t < _f2) {
      if (i > 0) {
        var _e3 = n[i - 1],
            _u2 = r(_e3);

        if (t > _u2) return t - _u2 >= _f2 - t ? _o3 : _e3;
      }

      l = i;
    } else {
      if (i < e) {
        var _e4 = n[i + 1],
            _u3 = r(_e4);

        if (t < _u3) return t - _f2 >= _u3 - t ? _e4 : _o3;
      }

      u = i + 1;
    }
  }

  return n[i];
}

function M(n) {
  return n.reduce(function (n, t) {
    return n.concat(t || []);
  }, []);
}

var w = function w() {
  _classCallCheck(this, w);

  this.last = 0;
};

var y = new w();

function b(n, t, r, e) {
  e = e || y;
  var o = Math.max(0, e.last - 10);

  for (var _u4 = o; _u4 < r; ++_u4) {
    if (n[_u4] === t) return e.last = _u4, _u4;
  }

  var f = Math.min(o, r);

  for (var _u5 = 0; _u5 < f; ++_u5) {
    if (n[_u5] === t) return e.last = _u5, _u5;
  }

  return -1;
}

function v(n, t, r, e) {
  var o = null == r ? n.length : r,
      f = b(n, t, o, e);
  if (-1 !== f) return n[f] = n[o - 1], null == r && n.pop(), t;
}

var A = new Set();

function O(n, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : n.length;
  var e = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t.length;
  var o = arguments.length > 4 ? arguments[4] : undefined;
  var f = arguments.length > 5 ? arguments[5] : undefined;
  if (0 === e || 0 === r) return r;
  A.clear();

  for (var _i = 0; _i < e; ++_i) {
    A.add(t[_i]);
  }

  o = o || y;
  var u = Math.max(0, o.last - 10);

  for (var _i2 = u; _i2 < r; ++_i2) {
    if (A.has(n[_i2]) && (f && f.push(n[_i2]), A.delete(n[_i2]), n[_i2] = n[r - 1], --r, --_i2, 0 === A.size || 0 === r)) return A.clear(), r;
  }

  for (var _i3 = 0; _i3 < u; ++_i3) {
    if (A.has(n[_i3]) && (f && f.push(n[_i3]), A.delete(n[_i3]), n[_i3] = n[r - 1], --r, --_i3, 0 === A.size || 0 === r)) return A.clear(), r;
  }

  return A.clear(), r;
}

function j(n, t, r) {
  var e = n.length;
  if (t >= e) return n.slice(0);
  var o = z(r),
      f = new Set(),
      u = [];

  for (; u.length < t;) {
    var _t = Math.floor(o() * e);

    f.has(_t) || (f.add(_t), u.push(n[_t]));
  }

  return u;
}

function z(n) {
  return n ? (S.seed = n, function () {
    return S.getFloat();
  }) : Math.random;
}

function I(n, t) {
  var r = z(t);

  for (var _e5 = n.length - 1; _e5 > 0; _e5--) {
    var _t2 = Math.floor(r() * (_e5 + 1)),
        _o4 = n[_e5];

    n[_e5] = n[_t2], n[_t2] = _o4;
  }

  return n;
}

var S = new t();

function C(n, t) {
  var r = n.indexOf(t);
  return -1 !== r ? (n.splice(r, 1), t) : null;
}

export { w as PositionHint, x as binaryFindClosest, p as binaryIndexOf, g as constant, c as difference, l as equals, r as first, M as flatten, b as indexOf, s as intersect, a as isArrayLike, e as last, f as max, u as min, j as pickRandom, m as range, C as remove, v as removeUnordered, O as removeUnorderedMany, I as shuffle, h as splitIntoChunks, i as unique };